import { Knopf } from "./knopf";

/**
 * Kopf einer Modul-Startseite (Startseiten-Prototyp): Titelleiste wie /heute,
 * Status-Abzeichen statt Status-Kacheln, rechts höchstens EINE Hauptaktion (Link).
 * Ob die Aktion erscheint, entscheidet der Aufrufer mit derselben Rechteprüfung wie
 * die Zielseite bzw. deren Server-Action (Anbieten nie großzügiger als Erlauben).
 */
export function StartseitenKopf({
  titel,
  untertitel,
  abzeichen,
  aktion,
  weitereAktionen,
}: {
  titel: string;
  untertitel: string;
  /** Status-Abzeichen (Badge-Bausteine). */
  abzeichen?: React.ReactNode;
  aktion?: { href: string; text: string };
  /**
   * Zusätzliche Knöpfe in DERSELBEN Aktionszeile vor der Hauptaktion (z. B. „Startseite anpassen“), damit alle Knöpfe des Kopfes auf einer
   * Linie stehen (Fix 20.10.2026: ein Knopf außerhalb des Kopfes stand oben statt mittig neben dem Titel).
   */
  weitereAktionen?: React.ReactNode;
}) {
  return (
    <>
      {/* Preline: navigation-and-layout/navigation-and-layout-sub-titles-footers/navigation-and-layout-cat-title-bars/subtitle-and-navigation-buttons */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-5">
        <div className="flex flex-wrap justify-between items-center gap-2">
          <div>
            <h1 className="text-lg md:text-xl font-semibold text-foreground">{titel}</h1>
            <p className="text-sm text-muted-foreground-1">{untertitel}</p>
            {abzeichen && <div className="mt-2 flex flex-wrap items-center gap-2">{abzeichen}</div>}
          </div>
        </div>

        {(aktion || weitereAktionen) && (
          <div className="inline-flex sm:justify-end items-center gap-x-3">
            {weitereAktionen}
            {/* Preline: feedback-and-states/feedback-and-states-sub-alerts-recovery/feedback-and-states-cat-empty-states/no-events-empty-state-with-import-and-create-actions */}
            {aktion && (
            <Knopf
              variante="primaer"
              groesse="sm"
              href={aktion.href}
              symbol={
                <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M5 12h14" />
                  <path d="M12 5v14" />
                </svg>
              }
            >
              {aktion.text}
            </Knopf>
            )}
          </div>
        )}
      </div>
    </>
  );
}
